// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPITable = makeThemedStyles('KPITable', () => ({
  KPITable: {
    display: 'table',
    color: '#333',
    width: '100%',
    padding: '10px',
    borderCollapse: 'collapse',
    backgroundColor: 'white',
    borderRadius: '6px'
  },

  popup: {
    width: '300px'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPITableContainer: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPITable();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.KPITable, {
        [styles.popup]: isVariantEnabled(props, 'popup')
      })}
    >
      {props?.children}
    </div>
  );
};
export default KPITableContainer;
